/**
 * API functions for Authentication endpoints
 */

import { request, setAuthToken, removeAuthToken } from './client'

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  token: string
  username: string
}

/**
 * Login with username and password
 *
 * @param credentials - Username and password
 * @returns Promise resolving to login response with JWT token
 */
export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const response = await request<LoginResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  })

  // Store token in localStorage
  if (response.token) {
    setAuthToken(response.token)
  }

  return response
}

/**
 * Logout - removes token from localStorage
 */
export function logout(): void {
  removeAuthToken()
}

/**
 * Check if user is authenticated (has valid token)
 */
export function isAuthenticated(): boolean {
  return !!localStorage.getItem('auth_token')
}
